import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Router } from 'react-router';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { SnackbarProvider } from 'notistack';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from 'auth/msalConfig';
import SnackbarNotifier from 'components/SnackbarNotifier';

import { createBrowserHistory } from 'history';
import { configureStore } from 'store/configureStore';
import App from 'App';
import StackMeasurementReport from 'features/stacks/pdf/StackMeasurementReport';
import { PdfLayout } from 'layouts/PdfLayout';

// Create browser history to use in the Redux store
const baseUrl: string | undefined =
  document.getElementsByTagName('base')[0].getAttribute('href') || undefined;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

ReactDOM.render(
  <BrowserRouter>
    <Router history={history}>
      <Switch>
        <Route path="/pdf/stack-measurement-report">
          <PdfLayout>
            <StackMeasurementReport />
          </PdfLayout>
        </Route>
        <Route>
          <MsalProvider instance={msalInstance}>
            <Provider store={store}>
              <HelmetProvider>
                <SnackbarProvider
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                >
                  <SnackbarNotifier />
                  <App />
                </SnackbarProvider>
              </HelmetProvider>
            </Provider>
          </MsalProvider>
        </Route>
      </Switch>
    </Router>
  </BrowserRouter>,
  document.getElementById('root'),
);
